'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transactionDiscardLocal = exports.transactionReceiptsFetchFailed = exports.transactionReceiptsFetched = exports.transactionProgressNotified = exports.transactionCreated = undefined;

var _actionTypes = require('../actionTypes');

var transactionCreated = exports.transactionCreated = function transactionCreated(transactionHash, id, actionType, label) {
  return {
    type: _actionTypes.TRANSACTION_CREATED,
    transactionHash: transactionHash,
    id: id,
    actionType: actionType,
    label: label
  };
};

var transactionProgressNotified = exports.transactionProgressNotified = function transactionProgressNotified(transactionHash, notificationId) {
  return {
    type: _actionTypes.TRANSACTION_PROGRESS_NOTIFIED,
    transactionHash: transactionHash,
    notificationId: notificationId
  };
};

var transactionReceiptsFetched = exports.transactionReceiptsFetched = function transactionReceiptsFetched(transactionReceipts) {
  return {
    type: _actionTypes.TRANSACTION_RECEIPTS_FETCHED,
    transactionReceipts: transactionReceipts
  };
};

var transactionReceiptsFetchFailed = exports.transactionReceiptsFetchFailed = function transactionReceiptsFetchFailed(error) {
  return {
    type: _actionTypes.TRANSACTION_RECEIPTS_FETCH_FAILED,
    error: error
  };
};

var transactionDiscardLocal = exports.transactionDiscardLocal = function transactionDiscardLocal(transactionHash) {
  return {
    type: _actionTypes.LOCAL_TRANSACTION_DISCARDED,
    transactionHash: transactionHash
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/actions/transactions.js
// module id = 284
// module chunks = 0